<template>
  <div class="pg_frm_popup pg_signup signup_widget widget_v2_1">

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" @keydown.enter="login">

          <div class="row head">
            <div class="col-3 logo_container">
              <img class="logo" src="../../../assets/theme/default/img/pragyaLogo.svg" alt="Pragya Systems Logo">
            </div>
            <div class="col-6">
              <div class="head_txt">Pragya Website Widgets</div>
            </div>
            <div class="col-3"></div>
          </div>

          <template v-if="!showSuccessMessage">
            <div class="row">
              <div class="col-xl-12">

                <div class="row">
                  <div class="col-1"></div>
                  <div class="col-10 welcome_txt" style="padding: 30px 15px;">
                    <p>
                      Students and their families are increasingly asking - is this educational program worth it?
                    </p>
                    <p>
                      Help learners make enrollment decisions, and showcase the ROI of your school’s educational
                      programs with our AI-powered tools that can be up and running on your website in seconds.
                    </p>
                  </div>
                </div>

                <div class="row sub_head">
                  <div class="col-1"></div>
                  <div class="col-10 head_txt" style="text-align: left; max-width: 427px;">
                    Free Pragya Career ROI Widget
                  </div>
                </div>

                <div class="row">
                  <div class="col-1"></div>
                  <div class="col-10 highlighted_bar">
                    <span class="ic_container">
                      <span class="ic ic8-gift"></span>
                    </span>
                    <span class="txt">
                      Completely Free, Forever*
                    </span>
                    <button @click="openROIWidgetFormModal">Get it Now</button>
                  </div>
                </div>

                <div class="row">
                  <div class="col-1"></div>
                  <div class="col-6 widget_feature">
                    <div class="pl-4">
                      <div class="hd">Articulate the ROI of your programs to prospects on your website</div>
                      <ul>
                        <li>Customized to your institution’s programs</li>
                        <li>Showcase key careers, income and growth outlook</li>
                        <li>Unlimited instances of widget. Enable exploration of career prospects of individual programs or all programs in one page</li>
                        <li>Up and running in seconds </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-4 widget_preview roi_widget">
                    <img src="../../../assets/module/img/widget/Free-ROI-Widget@2x.png" />
                  </div>
                </div>



                <div class="row bg_bar_2">
                  <div class="col-12">

                    <div class="row sub_head">
                      <div class="col-1"></div>
                      <div class="col-10 head_txt" style="text-align: left; max-width: 365px;">
                        Pragya for Lead Nurturing
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-1"></div>
                      <div class="col-10 highlighted_bar2">
                        <span class="ic_container">
                          <span class="ic ic8-hour-glass"></span>
                        </span>
                        <span class="txt">
                          Free for 90 days, revert to the Free Widget after that
                        </span>
                        <button @click="openLeadWidgetFormModal">Begin Trial </button>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-1"></div>
                      <div class="col-6 widget_feature">
                        <div class="pl-4">

                          <div class="hd">Everything in the Pragya Free Career ROI Widget</div>
                          <div class="hd add_sign">+</div>
                          <div class="hd">Enrollment Lead Capture</div>
                          <ul>
                            <li>Regional Labor market data from Burning Glass</li>
                            <li>Showcase Jobs, Employers Hiring in your region </li>
                            <li>Personalized app to help prospective students explore program offerings and career prospects</li>
                            <li>Multiple engagement points and calls to action (CTAs) </li>
                          </ul>

                          <div class="hd pt-3">Reporting and Insights</div>
                          <ul>
                            <li>Enrollment officer Dashboard </li>
                            <li>Downloadable prospects lists, fully qualified by widget activity </li>
                            <li>Capture qualified leads</li>
                            <li>Unlock insights into prospect interest and activity for targeted engagement</li>
                          </ul>

                        </div>
                      </div>
                      <div class="col-4 widget_preview lead_widget">
                        <img src="../../../assets/module/img/widget/Enhanced-Lead-Capture-Widget@2x.png" />
                      </div>
                    </div>

                  </div>
                </div>


                <div class="row sub_head">
                  <div class="col-1"></div>
                  <div class="col-10 head_txt" style="text-align: left; max-width: 302px;">
                    Compare the Widgets
                  </div>
                </div>

                <div class="row compare_widgets">
                  <div class="col-1"></div>

                  <div class="col-10 pb-4">

                    <table>
                      <thead>
                        <tr>
                          <td></td>
                          <td>Free</td>
                          <td>Pragya for Lead Nurturing</td>
                          <td>Pragya for Yield Improvement</td>
                        </tr>
                      </thead>

                      <tbody>

                        <tr class="tbl_sub_hd">
                          <td colspan="4">
                            <div class="sub_hd">Career ROI Widget</div>
                          </td>
                        </tr>

                        <tr>
                          <td>BLS powered national salary and career outlook data </td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Key Careers relevant to your program</td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Plug-and-Play on any website in seconds</td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Burning Glass powered regional career outlook and income data</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Top employers hiring nationally and in each US State and city</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Calls to Actions and Prospect Engagement hooks to capture leads</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Customize Widget Colors</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr class="tbl_sub_hd">
                          <td colspan="4">
                            <div class="sub_hd">Enrollment Counsellor Dashboard and Personalized Learner App</div>
                          </td>
                        </tr>

                        <tr>
                          <td>Download Prospect lists from widget lead capture </td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Widgets for social media campaigns </td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Showcase institutional program requirements and guided pathways</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Showcase additional academic and extracurricular content</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Showcase insights from Alumni pathways and career progression </td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Customize program to career crosswalk</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Customize “Call to Action” buttons in learner app to engage prospects</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Enrollment Marketing Support</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>CRM integration</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Single Sign on with your institution’s login</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Summer Melt Reduction Analytics</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Automation for Transfer Credit articulation</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col">
                            <a href="mailto:support@pragyasystems.com">Contact Us</a>
                          </td>
                        </tr>


                        <tr class="tbl_sub_hd">
                          <td colspan="4">
                            <div class="sub_hd">Support</div>
                          </td>
                        </tr>

                        <tr>
                          <td>Self help via support portal</td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Email and Chat Support</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Available Help Desk 24X7 support</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr>
                          <td>Marketing and Yield improvement consultation with our experts</td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"></td>
                          <td class="chk_bx_col"><span class="ic ic8-checkmark"></span></td>
                        </tr>

                        <tr class="tbl_sub_hd">
                          <td colspan="4">
                            <div class="sub_hd">Pricing</div>
                          </td>
                        </tr>

                        <tr>
                          <td></td>
                          <td class="chk_bx_col">Free</td>
                          <td class="chk_bx_col">Free for 3 months. $10 per lead per year if you decide to upgrade after that.</td>
                          <td class="chk_bx_col">
                            <a href="mailto:support@pragyasystems.com">Contact Us</a>
                          </td>
                        </tr>

                        <tr>
                          <td></td>
                          <td class="btn_col">
                            <b-button @click="openROIWidgetFormModal" aria-label="verify">Get the Free Widget</b-button>
                          </td>
                          <td class="btn_col">
                            <b-button @click="openLeadWidgetFormModal" aria-label="verify">Try for Free</b-button>
                          </td>
                          <td class="btn_col">
                            <a class="btn" href="https://site.pragyasystems.com/index/contact/" target="_blank">Contact Us</a>
                            <!--
                            <b-button @click="" aria-label="verify">Contact Us</b-button>
                            -->
                          </td>
                        </tr>


                      </tbody>
                    </table>

                  </div>
                </div>


              </div>
            </div>
          </template>
          <template v-if="showSuccessMessage && !notInTheList">
            <div class="row success_msg">
              <div class="col-12 msg_sec">
                <div class="msg_hd">
                  <h2>Please verify your email</h2>
                </div>
                <div class="msg_txt">
                  <p>
                    A link was sent to your email. <br/>
                    Follow the instructions in the email to complete sign up and be sure to check the spam folder too.
                  </p>
                  <p>
                    If you do not see the email, please send us an email at <a href="mailto:support@pragyasystems.com">support@pragyasystems.com</a>
                  </p>
                </div>
              </div>
            </div>
          </template>
          <template v-if="showSuccessMessage && notInTheList">
            <div class="row success_msg">
              <div class="col-12 msg_sec">
                <div class="msg_hd">
                  <h2>Thank you for your interest.</h2>
                </div>
                <div class="msg_txt">
                  We will be in touch soon! If you have questions, please reach out to us at support@pragyasystems.com
                </div>
              </div>
            </div>
          </template>

        </div>
      </div>


      <div class="row">
        <div class="col-12 copyright_info">
          © Copyright Pragya Systems Corp. All rights reserved.
        </div>
      </div>


      <div class="pg_frm_popup">
        <b-modal id="signupFormROIWidget" class="" ref="getROIWidgetFormModal" ok-disabled cancel-diasbled hide-footer no-close-on-backdrop no-close-on-esc centered>
          <div slot="modal-header" class="header-section">
            <div class="head_txt">
              Get your Free Pragya Career ROI Widget!
            </div>
            <div class="btn_container">
              <button class="btn_close" aria-label="close" @click="closeROIWidgetSignupModal">
              <span class="ic-close"></span>
              </button>
            </div>
          </div>
          <div class="frm_flds_box">
            <!--
            <div class="row page_fld_section">
              <div class="col-12 hd">
                ROI Widget
              </div>
            </div>
            -->
            <div class="row page_fld_section">
              <div class="col-12 fld_label">
                <div class="" id="eMail">Email<sup>*</sup></div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="email" v-model.email="eMail"  placeholder="Email" style="height: 1.5em !important;">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12 fld_label">
                <div class="" id="fname">First name <sup>*</sup></div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="text" v-model.trim="firstName" placeholder="First Name" style="height: 1.5em !important;">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12 fld_label">
                <div class="" id="lname">Last name <sup>*</sup></div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="text" v-model.trim="lastName" placeholder="Last Name" style="height: 1.5em !important;">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section" v-if="!notInTheList">
              <div class="col-12 fld_label">
                <div class="" id="institution">Institution</div>
              </div>
              <div class="col-12 fld_select">
                <v-select class="select-field" v-model='selectedInstitution'
                  :options="institutions" label="name" placeholder="Select or Search for your Institution"></v-select>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12 fld_label">
                <div class="" id="institution">If you don't see your institution check the box below.</div>
              </div>
              <div class="col-12 fld_select pt-1">
                <input type="checkbox" id="tnc_chkbox" v-model="notInTheList">
                <label for="tnc_chkbox">My Institution is not in the list</label>
              </div>
            </div>
            <div class="row page_fld_section" v-if="notInTheList">
              <div class="col-12 fld_label">
                <div class="" id="title">Institution Name</sup></div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="text" v-model.trim="notInTheListInstitutionName" placeholder="Institution Name" style="height: 1.5em !important;">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12 fld_label">
                <div class="" id="title">Your Title</sup></div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="text" v-model.trim="title" placeholder="Title" style="height: 1.5em !important;">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12 fld_label">
                <div class="" id="interest">Objectives</sup></div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="text" v-model.trim="interest" placeholder="Type In To Your Interest" style="height: 1.5em !important;">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12 btn_container">
                <b-button size="lg" @click="signUpUser" aria-label="verify">Get the Free widget</b-button>
              </div>
            </div>
          </div>
        </b-modal>
      </div>


      <div class="pg_frm_popup">
        <b-modal id="signupFormLeadWidget" class="" ref="signupLeadWidgetForm" ok-disabled cancel-diasbled hide-footer no-close-on-backdrop no-close-on-esc centered>
          <div slot="modal-header" class="header-section">
            <div class="head_txt">
              Try the Enhanced Lead Capture Widget!
            </div>
            <div class="btn_container">
              <button class="btn_close" aria-label="close" @click="closeLeadWidgetSignupModal">
              <span class="ic-close"></span>
              </button>
            </div>
          </div>
          <div class="frm_flds_box">
            <!--
            <div class="row page_fld_section">
              <div class="col-12 hd">
                Lead Capture Widget
              </div>
            </div>
            -->
            <div class="row page_fld_section">
              <div class="col-12 fld_label">
                <div class="" id="eMail">Email<sup>*</sup></div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="email" v-model.email="eMail"  placeholder="Email" style="height: 1.5em !important;">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12 fld_label">
                <div class="" id="fname">First name <sup>*</sup></div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="text" v-model.trim="firstName" placeholder="First Name" style="height: 1.5em !important;">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12 fld_label">
                <div class="" id="lname">Last name <sup>*</sup></div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="text" v-model.trim="lastName" placeholder="Last Name" style="height: 1.5em !important;">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section" v-if="!notInTheList">
              <div class="col-12 fld_label">
                <div class="" id="institution">Institution</div>
              </div>
              <div class="col-12 fld_select">
                <v-select class="select-field" v-model='selectedInstitution'
                  :options="institutions" label="name" placeholder="Select or Search for your Institution"></v-select>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12 fld_label">
                <div class="" id="institution">If you don't find your institution check the box below.</div>
              </div>
              <div class="col-12 fld_select">
                <input type="checkbox" id="tnc_chkbox" v-model="notInTheList">
                <label for="tnc_chkbox">My Institution is not in the list</label>
              </div>
            </div>
            <div class="row page_fld_section" v-if="notInTheList">
              <div class="col-12 fld_label">
                <div class="" id="title">Institution Name</sup></div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="text" v-model.trim="notInTheListInstitutionName" placeholder="Institution Name" style="height: 1.5em !important;">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12 fld_label">
                <div class="" id="title">Your Title</sup></div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="text" v-model.trim="title" placeholder="Title" style="height: 1.5em !important;">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12 fld_label">
                <div class="" id="interest">Your Interest</sup></div>
              </div>
              <div class="col-12 fld_input">
                <b-form-input type="text" v-model.trim="interest" placeholder="Type In To Your Interest" style="height: 1.5em !important;">
                </b-form-input>
              </div>
            </div>
            <div class="row page_fld_section">
              <div class="col-12 btn_container">
                <b-button size="lg" @click="signUpEnhancedWidget" aria-label="verify">Try the Lead Widget</b-button>
              </div>
            </div>
          </div>
        </b-modal>
      </div>


      <div class="loading-spinner">
        <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
          <div class="text-center" style="color: #FFF">
            <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
          </div>
        </b-modal>
      </div>

  </div>
</template>

<script>
  // import Vue from 'vue'
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'signupWidget',
    components: {
    },
    data: () => {
      return {
        eMail: '',
        firstName: '',
        lastName: '',
        title: '',
        interest: '',
        enhancedWidget: false,
        selectedInstitution: {},
        institutionOpenId: '',
        institutionName: '',
        showSuccessMessage: false,
        institutions: [],
        notInTheList: false,
        notInTheListInstitutionName: ''
      }
    },

    computed: {
      ...mapState({
      })
    },

    mounted () {
      this.loadVerificationPage()
    },

    methods: {
      ...mapActions([
        'loadSignupUser',
        'loadLogDashboardActivity',
        'loadPreCuratedInstitutions',
        'loadWidgetAdminSignUp',
        'loadWidgetAdminSignUpNotOnList'
      ]),
      async loadVerificationPage () {
        let response = await this.loadPreCuratedInstitutions()
        if (response && response.content) {
          this.institutions = response.content
        }
      },
      signUpEnhancedWidget () {
        this.enhancedWidget = true
        this.signUpUser()
      },
      closeROIWidgetSignupModal () {
        this.$root.$emit('bv::hide::modal', 'signupFormROIWidget')
      },
      closeLeadWidgetSignupModal () {
        this.$root.$emit('bv::hide::modal', 'signupFormLeadWidget')
      },
      async signUpUser () {
        this.institutionOpenId = this.selectedInstitution.externalId
        this.institutionName = this.notInTheList ? this.notInTheListInstitutionName: this.selectedInstitution.name
        let userObj = {
          'eMail': this.eMail,
          'firstName': this.firstName,
          'lastName': this.lastName,
          'institutionName': this.institutionName,
          'title': this.title,
          'interest': this.interest,
          'enhancedWidget': this.enhancedWidget
        }
        if (this.eMail.length < 1) {
          this.notifyFailure('Oops! Email is missing!')
        } else if (this.firstName.length < 1 || this.lastName.length < 1) {
          this.notifyFailure('Oops! First Name or Last Name is missing!')
        } else if (!this.notInTheList && (!this.institutionOpenId || this.institutionOpenId.length < 1)) {
          this.notifyFailure('Oops! Select an institution')
        } else {
          this.showLoader()
          let response = {}
          if (this.notInTheList) {
            response = await this.loadWidgetAdminSignUpNotOnList(userObj)
          } else {
            response = await this.loadWidgetAdminSignUp({ institutionOpenId: this.institutionOpenId, data: userObj})
          }
          setTimeout(() => {
            this.hideLoader()
          }, 1000)
          let status = response.status
          if (status === 200) {
            this.showSuccessMessage = true
          } else {
            this.notifyFailure('Oops! Please ensure the email is valid institution email')
          }
        }
      },
      openROIWidgetFormModal () {
        if (this.$refs.getROIWidgetFormModal) {
          this.$refs.getROIWidgetFormModal.show()
        }
      },
      openLeadWidgetFormModal () {
        if (this.$refs.signupLeadWidgetForm) {
          this.$refs.signupLeadWidgetForm.show()
        }
      },
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },

      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      },

      notifyFailure (text) {
        this.$notify({
          group: 'notify',
          type: 'error',
          title: '',
          text: text
        })
      }
    }
  }
</script>

<style scoped>
.color-white a {
  color: #ffffff;
}
.close_button {
  margin-top: 10px;
}
.img-institution-signup {
  width: 400px!important;
}
input[type="checkbox"] {
  border: solid 1px rgb(50, 50, 50) !important;
}
</style>



// WEBPACK FOOTER //
// src/app/login/components/SignupWidget.vue